/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { downloadBulkResult, getExportConfig, getShopUrl, getTrialStatus } from '../Services/CommonServices';
import { getPageImportHistory } from '../Services/PagService';
import { environment } from '../Services/environment';
import ExportStatusCard from '../common/ExportStatusCard';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import CustomProgressBar from '../common/CustomProgressBar';
import { useNavigate } from 'react-router-dom';
import WatermarkImage from '../../assets/3129492.jpg';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function ShopifyPage({blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [exportStatus, setExportStatus] = useState("");
    const [pageDeleteResult, setPageDeleteResult] = useState(null);
    const [pageMetaDeleteResult, setPageMetaDeleteResult] = useState(null);
    const [pageStatus, setPageStatus] = useState("");
    const [file, setFile] = useState();
    const [dropZoneKey, setDropZoneKey] = useState(0);  // Key to force dropzone re-render
    const [pageErrors, setPageErrors] = useState([]);
    const [pageErrorActive, setPageErrorActive] = useState(false);
    const handlePageErrorChangeModal = useCallback(() => setPageErrorActive(!pageErrorActive), [pageErrorActive]);
    const [popoverActive, setPopoverActive] = useState(false);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [FileErrors, setFileErrors] = useState([])
    const [loadingMap, setLoadingMap] = useState({});
    const [validationErrModalActive, setValidationErrModalActive] = useState(false);
    const handleValidationErrorChangeModal = useCallback(() => setValidationErrModalActive(!validationErrModalActive), [validationErrModalActive]);
    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setFile(acceptedFiles[0]);
            setRejectedFiles(_rejectedFiles[0]);
        },
        [],
    );
    const resourceName = {
        singular: 'log',
        plural: 'logs'
    };
    const pageSize = 10;
    const [pageDeleteStatus, setPageDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [exportLoading, setExportLoading] = useState(false);
    const [importLoading, setImportLoading] = useState(false);
    
    // Trial authorization state
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);
    const [ChargeUrl, setChargeUrl] = useState("");
    
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [comparePages, setComparePages] = useState();
    const [uploadStatus, setUploadStatus] = useState(false);
    const [notificationResult, setNotificationResult] = useState(undefined);
    const [retryCount, setRetryCount] = useState(0);
    const SSE_RETRY_DELAY = 5000;
    const exportRequestInFlightRef = useRef(false);
    useEffect(() => {
        getConfigExport();
        // CheckExportStatus();
        getLogs();
        loadTrialStatus(); // Load trial status on mount
    }, []);

    // Refetch export config when export completes
    useEffect(() => {
        if (exportStatus === "completed" || exportStatus === "failed") {
            // Small delay to ensure backend has updated the config
            const timer = setTimeout(() => {
                getConfigExport();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [exportStatus]);

    // Trial authorization helper functions
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true;
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };
    useEffect(() => {
        if (eventSource) {

        eventSource.onmessage = (event) => {
            const data = event.data;
            if (data.includes("pagecatalogextract")) {
                setImportLoading(false);
                const jsonObject = JSON.parse(data);
                setUploadStatus(true);
                setPageStatus("processing");
                setCatalogExtractMsg(jsonObject);
                setProcessingMsg("Catalog extract");
            }
            else if (data.includes("pagescompare")) {
                setImportLoading(false);
                const jsonObject = JSON.parse(data);
                setUploadStatus(true);
                setPageStatus("processing");
                setComparePages(jsonObject);
                setProcessingMsg("Compare pages");
            }
            else if (data.includes("pageuploadbulk")) {
                setImportLoading(false);
                setUploadStatus(true);
                const jsonObject = JSON.parse(data);
                setNotificationResult(jsonObject)
            } else if (data.includes("pageimportcompleted")) {
                setImportLoading(false);
                setNotificationResult(undefined);
                getLogs();
                setUploadStatus(false);
                setFile(null);  // Reset file state to allow new uploads
                setRejectedFiles(null);  // Reset rejected files
                setDropZoneKey(prev => prev + 1);  // Force dropzone re-render
                setPageStatus("");  // Reset page status
                setProcessingMsg("calculating items");  // Reset processing message
                setCatalogExtractMsg(undefined);  // Reset catalog extract message
                setComparePages(undefined);  // Reset compare pages
            } else if (data.includes("pagedownloadComplete")) {
                setExportStatus("completed");
                exportRequestInFlightRef.current = false;
                // if (exportConfig === null && !isExportConfig) {
                //     isExportConfig = true;
                setExportLoading(false);
                    getConfigExport();
                // }
                // window.location.href = endpoint + '/api/Page/download-previous-export?storeUrl=' + storeUrl;
                setExportLoading(false);
                setDownloadSpinner(false);
            }

            else if (data.includes("Page delete")) {
                setUploadStatus(true);
                setPageStatus("processing")
                setProcessingMsg("Page delete")
                setPageDeleteStatus(JSON.parse(data));
            } 

            else if (data.includes("Page meta delete")) {
                setUploadStatus(true);
                setPageStatus("processing")
                setProcessingMsg("Metafield delete")
                setMetaDeleteStatus(JSON.parse(data));
            } 

            else if (data.includes("PageExport")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    setExportResult(jsonObject)
                    if (jsonObject.status?.toLowerCase() === "completed" || jsonObject.status?.toLowerCase() === "failed") {
                        exportRequestInFlightRef.current = false;
                    }
                }
            }

            else if (data.includes("page-task-status")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;
                    const { type } = jsonObject;
                    if (type === "pageDelete") {
                        if (status.toLowerCase() === "completed") {
                            setPageDeleteResult(null);
                            getLogs();
                        } else if (status.toLowerCase() === "canceled") {
                        } else if (status.toLowerCase() === "running") {
                            setPageDeleteResult(jsonObject);
                        }
                    }
                }
            }

            else if (data.includes("page-meta-task-status")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;
                    const { type } = jsonObject;
                    if (type === "pageMetaDelete") {
                        if (status.toLowerCase() === "completed") {
                            setPageMetaDeleteResult(null);
                            getLogs();
                        } else if (status.toLowerCase() === "canceled") {
                        } else if (status.toLowerCase() === "running") {
                            setPageMetaDeleteResult(jsonObject);
                        }
                    }
                }
            }

            else if (data.includes("pagefailed")) {
                setExportStatus("failed");
                exportRequestInFlightRef.current = false;
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    getConfigExport();
                }
                setExportLoading(false);
                setDownloadSpinner(false);
                setNotificationResult(undefined)
            }
            else if (data.includes("pageValidation")) {
                const { pageValidation } = JSON.parse(data);
                if (pageValidation === true) {
                } else {
                    setFile(null);
                    setFileErrors(JSON.parse(data));
                    setProcessingMsg("failed");
                    setPageStatus("failed")
                    setImportLoading(false);
                    setUploadStatus(false);
                    setUploadBtnLoading(false);
                    setValidationErrModalActive(true);;
                }
            }
        }
        
    }
        return () => {
          if (eventSource) {
            eventSource.onmessage = null; // Remove the event handler
          }
        };
        }, [eventSource]);


    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );
    
    // Memoized UI Components
    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" alignment="center">
                <s-thumbnail
                    size="small"
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : ''
                    }
                />
                <div>
                    <s-text>
                        {file.name}
                    </s-text>
                    <s-text>
                        {file.size} bytes
                    </s-text>
                </div>
            </s-stack>
        )
    , [file, validFileTypes]);

    var pageDeleteNotification = (
        <>
            {pageDeleteResult !== undefined && pageDeleteResult !== null ? (
                <s-section>
                  <s-stack direction="inline" alignment="space-between">
                    <s-stack direction="inline" gap="small">
                      <s-icon
                        type="alert-circle"
                        tone={pageDeleteResult.status === "failed" ? "critical" : "subdued"}
                      />
                      <s-badge tone={pageDeleteResult.status === "failed" ? "critical" : "info"}>
                        {pageDeleteResult.status}
                      </s-badge>
                      <s-text type="strong">Delete</s-text>
                    </s-stack>
              
                    <s-text>
                      Pending: <s-text type="strong">{pageDeleteResult.pending}</s-text>
                    </s-text>
                  </s-stack>
                </s-section>
            ) : null}
        </>
    );

    var pageMetaDeleteNotification = (
        <>
            {pageMetaDeleteResult !== undefined && pageMetaDeleteResult !== null ? (
                <s-section>
                  <s-stack direction="inline" alignment="space-between">
                    <s-stack direction="inline" gap="small">
                      <s-icon
                        type="alert-circle"
                        tone={pageMetaDeleteResult.status === "failed" ? "critical" : "subdued"}
                      />
                      <s-badge tone={pageMetaDeleteResult.status === "failed" ? "critical" : "info"}>
                        {pageMetaDeleteResult.status}
                      </s-badge>
                      <s-text type="strong">Delete</s-text>
                    </s-stack>
              
                    <s-text>
                      Pending: <s-text type="strong">{pageMetaDeleteResult.pending}</s-text>
                    </s-text>
                  </s-stack>
                </s-section>
            ) : null}
        </>
    );


    const pageResponseErrorModal = (
        <s-modal
            size="large"
            open={pageErrorActive}
            onClose={handlePageErrorChangeModal}
        >
            <div slot="title">Failed pages</div>
            
            <s-box padding="large">
                <s-stack gap="large">
                    {pageErrors.map(({ handle, error }, index) => (
                        <s-stack key={index} gap="extra-small">
                            <s-text>#{index + 1} Handle: {handle}</s-text>
                            <s-banner tone="critical">
                                {error}
                            </s-banner>
                        </s-stack>
                    ))}
                </s-stack>
            </s-box>
            
            <div slot="footer">
                <s-button onClick={handlePageErrorChangeModal}>
                    Close
                </s-button>
            </div>
        </s-modal>
    );

console.log("Logs:", logs, logs.length);
    var importPageLogs = (
        <s-table
        padding="none"
            loading={logsLoading}
            paginate={logs.length > 0}
            hasPreviousPage={prvButton}
            hasNextPage={nxtButton}
            onPreviousPage={() => prev()}
            onNextPage={() => next()}
        >
            <s-table-header-row>
                <s-table-header>Id</s-table-header>
                <s-table-header>Type</s-table-header>
                <s-table-header>Created at</s-table-header>
                <s-table-header>Items</s-table-header>
                <s-table-header>Duration</s-table-header>
                <s-table-header>Errors</s-table-header>
                <s-table-header>Status</s-table-header>
            </s-table-header-row>
            <s-table-body>
                {logs.length === 0 ? (
                    <s-table-row>
                        <s-table-cell colSpan="7">
                            <s-box padding="large">
                                <s-stack alignment="center">
                                    <s-text>No logs yet</s-text>
                                </s-stack>
                            </s-box>
                        </s-table-cell>
                    </s-table-row>
                ) : 
                logs.map(
                    ({ id, bulkId, update, create, pageDelete, status, catalogUrl, updateStartTime, updateEndTime, createStartTime, createEndTime, metaDelete }, index) => (
                        <>
                            {update ?
                                <s-table-row
                                    id={bulkId}
                                    position={index}
                                    key={bulkId + "update"}
                                >
                                    <s-table-cell>
                                        <s-stack direction="inline" gap="small" alignment="center">
                                            <s-text type="strong">{'#' + id}</s-text>
                                            {catalogUrl ? (
                                                <s-link url={catalogUrl} download={catalogUrl.split('/').pop()}>
                                                    <s-icon type="upload" tone='base' />
                                                </s-link>
                                            ) : null}
                                        </s-stack>
                                    </s-table-cell>
                                    <s-table-cell><s-text type="strong">Update</s-text></s-table-cell>
                                    <s-table-cell>{update?.timeAgo}</s-table-cell>
                                    <s-table-cell>{update?.total}</s-table-cell>
                                    <s-table-cell>{update?.endTime ? FormatTimeDuration(update?.startTime, update?.endTime) : "_"}</s-table-cell>
                                    <s-table-cell>
                                        {(update?.errors && update?.errors?.length > 0) ?
                                            <s-link tone="critical" onClick={() => generateProdutErrorModal(update?.errors)}>
                                                <s-text tone="critical">{update?.errors?.length} errors</s-text>
                                            </s-link>
                                            : <s-text tone="success">{status !== "canceled" ? "_" : "_"}</s-text>
                                        }
                                    </s-table-cell>
                                    <s-table-cell>
                                        {status !== "canceled" ?
                                            <s-badge tone={update?.status === "completed" ? "success" : "info"}>{update?.status}</s-badge>
                                            : <s-badge tone="critical">{status}</s-badge>
                                        }
                                    </s-table-cell>
                                </s-table-row> : null}

                            {create ?
                                <s-table-row key={bulkId + "create"}>
                                    <s-table-cell>
                                        <s-stack direction="inline" gap="small" alignment="center">
                                            <s-text type="strong">{update ? "" : '#' + id}</s-text>
                                            {catalogUrl && !update ? (
                                                <s-link url={catalogUrl} download={catalogUrl.split('/').pop()}>
                                                    <s-icon type="upload" tone='base' />
                                                </s-link>
                                            ) : null}
                                        </s-stack>
                                    </s-table-cell>
                                    <s-table-cell><s-text type="strong">Create</s-text></s-table-cell>
                                    <s-table-cell>{create?.startTime ? create?.timeAgo : update?.timeAgo}</s-table-cell>
                                    <s-table-cell>{create?.total}</s-table-cell>
                                    <s-table-cell>{create?.endTime ? FormatTimeDuration(create?.startTime, create?.endTime) : "_"}</s-table-cell>
                                    <s-table-cell>
                                        {(create?.errors && create?.errors?.length > 0) ?
                                            <s-link tone="critical" onClick={() => generateProdutErrorModal(create?.errors)}>
                                                <s-text tone="critical">{create?.errors?.length} errors</s-text>
                                            </s-link>
                                            : <s-text tone="success">{status !== "canceled" ? "_" : "_"}</s-text>
                                        }
                                    </s-table-cell>
                                    <s-table-cell>
                                        {status !== "canceled" ?
                                            <s-badge tone={create?.status === "completed" ? "success" : "info"}>{create?.status}</s-badge>
                                            : <s-badge tone="critical">{status}</s-badge>
                                        }
                                    </s-table-cell>
                                </s-table-row> : null}

                            {pageDelete ?
                                <s-table-row key={bulkId + "pageDelete"}>
                                    <s-table-cell>
                                        <s-stack direction="inline" gap="small" alignment="center">
                                            {catalogUrl && !update && !create ? (
                                                <>
                                                    <s-text type="strong">{'#' + id}</s-text>
                                                    <s-link url={catalogUrl} download={catalogUrl.split('/').pop()}>
                                                        <s-icon type="upload" tone='base' />
                                                    </s-link>
                                                </>
                                            ) : null}
                                        </s-stack>
                                    </s-table-cell>
                                    <s-table-cell><s-text type="strong">Delete pages</s-text></s-table-cell>
                                    <s-table-cell>{pageDelete?.timeAgo}</s-table-cell>
                                    <s-table-cell>{pageDelete?.total}</s-table-cell>
                                    <s-table-cell>{"_"}</s-table-cell>
                                    <s-table-cell>{"_"}</s-table-cell>
                                    <s-table-cell>
                                        <s-badge tone={pageDelete?.completed === pageDelete?.total ? "success" : "info"}>
                                            {pageDelete?.completed === pageDelete?.total ? "completed" : "running"}
                                        </s-badge>
                                    </s-table-cell>
                                </s-table-row> : null}

                            {metaDelete ?
                                <s-table-row key={bulkId + "metaDelete"}>
                                    <s-table-cell>
                                        <s-stack direction="inline" gap="small" alignment="center">
                                            {catalogUrl && !update && !create && !pageDelete ? (
                                                <>
                                                    <s-text type="strong">{'#' + id}</s-text>
                                                    <s-link url={catalogUrl} download={catalogUrl.split('/').pop()}>
                                                        <s-icon type="upload" tone='base' />
                                                    </s-link>
                                                </>
                                            ) : null}
                                        </s-stack>
                                    </s-table-cell>
                                    <s-table-cell><s-text type="strong">Delete metafields</s-text></s-table-cell>
                                    <s-table-cell>{metaDelete?.timeAgo}</s-table-cell>
                                    <s-table-cell>{metaDelete?.total}</s-table-cell>
                                    <s-table-cell>{"_"}</s-table-cell>
                                    <s-table-cell>{"_"}</s-table-cell>
                                    <s-table-cell>
                                        <s-badge tone={metaDelete?.completed === metaDelete?.total ? "success" : "info"}>
                                            {metaDelete?.completed === metaDelete?.total ? "completed" : "running"}
                                        </s-badge>
                                    </s-table-cell>
                                </s-table-row> : null}
                        </>
                    )
                )}
            </s-table-body>
        </s-table>
    );

    // const validationErrorModel = (
    //     <div style={{ height: '500px' }}>
    //         <Modal
    //             open={validationErrModalActive}
    //             onClose={handleValidationErrorChangeModal}
    //             title={<Text tone="critical">Failed!</Text>}
    //         >
    //             <Modal.Section>
    //                 <VerticalStack gap="2">
    //                     <InlineError message={FileErrors.toString()} fieldID="myFieldIqD" />
    //                 </VerticalStack>
    //             </Modal.Section>
    //         </Modal>
    //     </div>
    // );

    const validationErrorModel = (
        <div style={{ height: '500px' }}>
            <s-modal
                open={validationErrModalActive}
                onClose={handleValidationErrorChangeModal}
            >
                <div slot="title">
                    <s-text tone="critical" type="strong">Issues found in the file</s-text>
                </div>
                
                <s-box padding="large">
                    <s-stack gap="medium">
                        <s-banner tone="critical">
                            {FileErrors?.errorType}
                        </s-banner>
                        <s-stack gap="extra-small">
                            {FileErrors?.errors?.map((error, index) => (
                                <s-text key={index}>{`${index + 1}. ${error}`}</s-text>
                            ))}
                        </s-stack>
                    </s-stack>
                </s-box>
                
                <div slot="footer">
                    <s-button onClick={handleValidationErrorChangeModal}>
                        Close
                    </s-button>
                </div>
            </s-modal>
        </div>
    );

    const notificationIndexTable = (item) => {
        return (
            <s-box paddingBlockStart="base">
            <s-section padding="none">
                <s-box padding="base">
                <s-grid gridTemplateColumns="1fr auto" gap="none">
                    <s-grid-item>
                        <s-heading>Current bulk operation: Pages</s-heading>
                    </s-grid-item>
                    <s-grid-item>
                        <s-button
                            variant='tertiary'
                            // onClick={() => { cancelBulk(normalizedItem?.bulkId) }}
                            icon="x"
                        >
                            {/* {bulkCancelStatus === "" ? "Cancel" : <s-text tone='warning'>{bulkCancelStatus}</s-text>} */}
                        Cancel
                        </s-button>
                    </s-grid-item>
                </s-grid>
                </s-box>
                <s-table>
                    <s-table-header-row>
                        <s-table-header>Id</s-table-header>
                        <s-table-header>Type</s-table-header>
                        <s-table-header>Created at</s-table-header>
                        <s-table-header>Items</s-table-header>
                        <s-table-header>Progress</s-table-header>
                        <s-table-header>Duration</s-table-header>
                        <s-table-header>Errors</s-table-header>
                        <s-table-header>Status</s-table-header>
                    </s-table-header-row>
                    <s-table-body>
                    {item.update ?
                        <s-table-row
                            id={1}
                            key={1}
                        >
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{'#' + item.id}</s-text>
                                    {item.catalogUrl ? (
                                        <s-link url={item.catalogUrl} download={item.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Update</s-text></s-table-cell>
                            <s-table-cell>{item.updateStartTime ? item.update?.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item.update.completed + "/" + item.update.total}</s-table-cell>
                            <s-table-cell><div style={{ width: '125px' }}>
                                <CustomProgressBar progress={item.update.completed != 0 ? (item.update.completed / item.update.total) * 100 : 0} />
                            </div></s-table-cell>
                            <s-table-cell>{item.updateEndTime ? FormatTimeDuration(item.updateStartTime, item.updateEndTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item.update.errors && item.update.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProdutErrorModal(item.update.errors)}>
                                    <s-text tone="critical">{item.update.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">_</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={item.update.status === "completed" ? "success" : "info"}>{item.update.status}</s-badge></s-table-cell>
                        </s-table-row> : null}
                    {item.create ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item.update ? "" : '#' + item.id}</s-text>
                                    {item.catalogUrl && item.update === null ? (
                                        <s-link url={item.catalogUrl} download={item.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Create</s-text></s-table-cell>
                            <s-table-cell>{item.createStartTime ? item.create?.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item.create.completed + "/" + item.create.total}</s-table-cell>
                            <s-table-cell><div style={{ width: '125px' }}>
                                <CustomProgressBar progress={item.create.completed != 0 ? (item.create.completed / item.create.total) * 100 : 0} />
                            </div></s-table-cell>
                            <s-table-cell>{item.createEndTime ? FormatTimeDuration(item.createStartTime, item.createEndTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item.create.errors && item.create.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProdutErrorModal(item.create.errors)}>
                                    <s-text tone="critical">{item.create.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={item.create.status === "completed" ? "success" : "info"}>{item.create.status}</s-badge></s-table-cell>
                        </s-table-row> : null}
                    </s-table-body>
                </s-table>
                </s-section>
                </s-box>
        );
    }

    const processingStatus = () => {
        if (uploadStatus) {
            
            if (notificationResult !== undefined) {
                return (notificationIndexTable(notificationResult))
            }
            if (pageStatus === "validating" || pageStatus === "processing" || pageStatus === "failed") {
                return (
                    <s-box paddingBlockStart="base">
                    <s-section padding="base">
                      <s-table selectable={false}>
                        <s-table-body>
                          <s-table-row>
                            <s-table-cell>
                              <s-stack direction="inline" gap="small" alignment="leading">
                                {pageStatus !== "failed" ? <s-spinner size="small" /> : null}
                                <s-badge tone={pageStatus === "failed" ? "critical" : "info"}>
                                  {pageStatus}
                                </s-badge>
                              </s-stack>
                            </s-table-cell>
                            
                            <s-table-cell style={{ textAlign: 'right', width: '100%' }}>
                              {pageStatus === "failed" ? (
                                <s-link onClick={() => setValidationErrModalActive(true)}>
                                  <s-text tone="critical">errors</s-text>
                                </s-link>
                              ) : (
                                <>
                                  {processingMsg === "Catalog extract" && (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>
                                        {catalogExtractMsg.type === "pagecatalogextract"
                                          ? "Catalog extract"
                                          : catalogExtractMsg.type}
                                      </s-text>
                                      <s-text type="strong">
                                        {catalogExtractMsg.status}
                                      </s-text>
                                    </s-stack>
                                  )}
                            
                                  {processingMsg === "Page delete" && (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>{pageDeleteStatus.status}</s-text>
                                      <s-text type="strong">
                                        {pageDeleteStatus.progress}
                                      </s-text>
                                    </s-stack>
                                  )}
                            
                                  {processingMsg === "Metafield delete" && (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>Metafield delete</s-text>
                                      <s-text type="strong">
                                        {metaDeleteStatus.progress}
                                      </s-text>
                                    </s-stack>
                                  )}
                            
                                  {processingMsg === "Compare pages" && (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>Update: <s-text type="strong">{comparePages.update}</s-text></s-text>
                                      <s-text>Create: <s-text type="strong">{comparePages.create}</s-text></s-text>
                                      <s-text>Delete: <s-text type="strong">{comparePages.delete}</s-text></s-text>
                                      <s-text>Metafield delete: <s-text type="strong">{comparePages.metaDelete}</s-text></s-text>
                                    </s-stack>
                                  )}
                                  
                                  {!["Catalog extract", "Page delete", "Metafield delete", "Compare pages"].includes(processingMsg) && (
                                    <s-stack direction="inline" alignment="trailing" blockAlign="center" gap="small">
                                      <s-text>
                                        {processingMsg === "validating"
                                          ? "parsing the file"
                                          : processingMsg}
                                      </s-text>
                                    </s-stack>
                                  )}
                                </>
                              )}
                            </s-table-cell>
                          </s-table-row>
                        </s-table-body>
                      </s-table>
                    </s-section>
                    </s-box>
                );
            }
            
        }
        
    }


    // var exportStatusBanner = (
    //     <Banner
    //         title={exportStatus === "completed" ? "Export completed" : "Export " + exportStatus}
    //         action={{
    //             content: 'Download Exported File', loading: exportLoading,disabled: exportStatus === "failed" ? true : false, onAction: () => {
    //                 setExportLoading(true);
    //                 window.location.href = endpoint + '/api/Page/download-previous-export?storeUrl=' + storeUrl;
    //             }
    //         }}
    //         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //         onDismiss={() => setExportStatus("")}>
    //             {exportStatus === "running" ? <p>This may take a few moments.</p> : null}
    //     </Banner>
    // );

    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [exportModalActive, setExportModalActive] = useState(false);
    const exportModal = (
        <>
            <s-modal
                open={exportModalActive}
                onClose={() => {setExportModalActive(false)}}
            >
                <div slot="title">Export</div>
                
                <s-box padding="large">
                    <s-banner
                        tone={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
                        onDismiss={false}
                    >
                        <s-text>
                            { exportStatus === "completed" ? "Export completed. " : "Export " + exportStatus }
                            { exportStatus === "running" ? " This may take a few moments." : null}
                            {exportStatus === "completed" && !downloadSpinner? <s-link url="" onClick={() => {
                                    setDownloadSpinner(true);
                                    window.location.href = endpoint + '/api/Page/download-previous-export?storeUrl=' + storeUrl;
                                }}>Download</s-link> : downloadSpinner ? <s-spinner  size="small"/> : null}
                        </s-text>
                    </s-banner>
                </s-box>
                
                <div slot="footer">
                    <s-button-group>
                        <s-button 
                            variant="primary"
                            onClick={exportAllPages}
                            disabled={exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false}
                        >
                            Export
                        </s-button>
                        <s-button onClick={() => {setExportModalActive(false)}}>
                            Cancel
                        </s-button>
                    </s-button-group>
                </div>
            </s-modal>
        </>
    );


    return (
        <s-page heading='Pages'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                onClick={() => { exportAllPages() }}
                disabled={blockUpload || exportLoading || exportStatus === "running"}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`  ${exportStatus}${exportStatus !== "failed" ? " This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>
            
            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />

            {/* {exportStatus !== ""  && !blockUpload ? exportStatusBanner : null } */}
            
            {/* Main Card - Two columns layout with grid */}
            <s-stack gap="base">
            <s-section padding="base">
                <s-box padding="none">
                    <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                        <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                {/* DropZone Section */}
                                <s-stack gap="small-100">
                                    <s-heading>Upload File</s-heading>
                                    <s-link onClick={() => openSampleFile()}>
                                        Download a sample file
                                    </s-link>
                                    
                                    <s-drop-zone
                                        key={dropZoneKey}
                                        multiple={false}
                                        accept=".csv,.xlsx"
                                        onInput={(event) => {
                                            const files = event.currentTarget.files;
                                            if (files && files.length > 0) {
                                                handleDropZoneDrop([], Array.from(files), []);
                                            }
                                        }}
                                    >
                                        {uploadedFile}
                                        {fileUpload}
                                    </s-drop-zone>
                                    
                                    <s-text color="subdued">
                                        Accepts .csv/.xlsx format. Maximum size: 20 MB
                                    </s-text>
                                </s-stack>

                                {/* Action Buttons Section */}
                                <s-stack gap="small-100">
                                    <s-stack direction="inline" gap="small">
                                        <s-button
                                            variant="primary"
                                            disabled={!file || uploadStatus || blockUpload}
                                            loading={importLoading}
                                            onClick={() => FileUploadValidation()}
                                        >
                                            Upload
                                        </s-button>
                                        {/* <s-button 
                                            variant="secondary" 
                                            onClick={() => openSampleFile()}
                                        >
                                            Download sample
                                        </s-button> */}
                                    </s-stack>
                                    
                                    {hasError && (
                                        <s-text as="p" tone="critical">
                                            {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                        </s-text>
                                    )}
                                </s-stack>
                            </s-stack>
                        </s-grid-item>
                        
                        <s-grid-item gridColumn="span 6">
                            {/* Note Section with Image Watermark */}
                            <div style={{ position: 'relative'}}>
                                {/* Watermark Image Background */}
                                <div 
                                    style={{
                                        position: 'absolute',
                                        bottom: '-65px',
                                        right: '10px',
                                        width: '300px',
                                        height: '300px',
                                        backgroundImage: `url(${WatermarkImage})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'bottom right',
                                        opacity: '0.15',
                                        pointerEvents: 'none',
                                        zIndex: 0
                                    }}
                                />
                                
                                {/* Note Content - On top of watermark */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <s-stack gap="small-100">
                                        <s-heading>Note</s-heading>
                                        <s-unordered-list>
                                            <s-list-item>
                                                Metafields are separate column headers with the format: <s-text type="strong">page/namespace/metafield-name/type</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls in metafields can be comma(,) separated in the first row of the page.
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in Shopify
                                            </s-list-item>
                                            <s-list-item>
                                                The app supports bulk operations for pages and their metafields efficiently
                                            </s-list-item>
                                        </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                        </s-grid-item>
                    </s-grid>
                </s-box>
            </s-section>
            </s-stack>
            {processingStatus()}
            {pageDeleteNotification}
            {pageMetaDeleteNotification}
            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" ?
                
                    <ExportStatusCard exportResult={exportResult} progress={0} exportConfig={exportConfig} currentRoute="page" />
                 : null}
            
            {/* Import History Section */}
            <s-box paddingBlockStart= "base">
            <s-section padding="none">
                <s-box padding="base">
                    <s-grid gridTemplateColumns="1fr auto" gap="none">
                        <s-heading>History</s-heading>
                        <s-box padding-block-end="small-200">
                            <s-text tone="subdued">
                                Imports from last 7 days
                            </s-text>
                        </s-box>
                    </s-grid>
                </s-box>
                
                {importPageLogs}
            </s-section>
            </s-box>
            {exportModal}
            {pageResponseErrorModal}
            {validationErrorModel}
        </s-page>
    );

    function FileUploadValidation() {
        // Check trial access first
        if (!checkTrialAccess()) {
            return;
        }

        setImportLoading(true);
        setPageStatus("validating")
        setProcessingMsg("validating");
        if (file !== null) {
            const formData = new FormData();
            formData.append("file", file);
            const requestOptions = {
                method: 'POST',
                body: formData
            };
            try {
                fetch(endpoint + '/api/page/import-pages?storeUrl=' + storeUrl, requestOptions)
                    .then(response => {
                        if (response.status === 500) {
                            return response.json()
                                .then(errors => {
                                    manageException(errors);
                                })

                        } else {
                            setFile(null);
                        }
                    })
                    .catch(err => {
                        manageException(err);

                    });
            } catch (error) {
                manageException(error);
            }
        }
    }

    function manageException(err) {
        setFile(null);
        setUploadBtnLoading(false);
        setImportLoading(false);
        const errors = [];
        if (err.message.includes("CsvRecordTooLargeException")) {
            errors.push("The CSV file contains records that are too large. Please check your data and try again.");
        } else {
            errors.push("An unexpected error occurred. Please try again later.");
        }

        setFileErrors({
            errorType: "File Upload Error",
            errors,
        });
        setValidationErrModalActive(true);
    }

    function FormatTimeDuration(startTime, endTime) {
        var createdAt = new Date(startTime);
        var completedAt = new Date(endTime);
        var diffMs = (completedAt - createdAt); // milliseconds between now & Christmas
        var diffSec = ((diffMs % 60000) / 1000).toFixed(0); // seconds
        var diffDays = Math.floor(diffMs / 86400000); // days
        var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        var days = diffDays > 0 ? (diffDays + diffDays === 1 ? "d " : "d ") : "";
        var hours = diffHrs > 0 ? diffHrs + "h " : ""
        var mins = diffMins > 0 ? diffMins + "m " : ""
        var secs = diffSec > 0 ? diffSec + "s" : "1s"
        var duration = days + hours + mins + secs;
        return duration;
    }

    function generateProdutErrorModal(errors) {
        setPageErrors(errors);
        setPageErrorActive(true)
    }

    // function CheckExportStatus() {
    //     setExportLoading(true);
    //     PageExportStatus(storeUrl)
    //         .then(res => {
    //             if (res === "completed") {
    //                 setExportLoading(false);
    //                 setDownloadSpinner(false);
    //                 setExportStatus(res);
                    
    //             }
    //             else if (res === "failed") {
    //                 setExportLoading(false);
    //                 setDownloadSpinner(false);
    //                 setExportStatus(res);
    //             }
    //             else {
    //                 setExportLoading(true);
    //                 setExportStatus(res);
    //             }
    //         })
    // }

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function exportAllPages() {
        if (exportRequestInFlightRef.current || exportLoading || exportStatus === "running") {
            return;
        }

        // Check trial access first
        if (!checkTrialAccess()) {
            return;
        }

        exportRequestInFlightRef.current = true;
        setExportLoading(true);
        setExportStatus("running");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(endpoint + '/api/Page/page-export?storeUrl=' + storeUrl, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                } else if (response.status === 400) {
                    exportRequestInFlightRef.current = false;
                    setExportLoading(false);
                    setExportStatus("failed");
                    return response.statusText;
                }
            })
            .catch(error => {
                exportRequestInFlightRef.current = false;
                setExportLoading(false);
                setExportStatus("failed");
            });
        return;
    }
    

    function getLogs() {
        setLogsLoading(true);
        getPageImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }

    function openSampleFile() {
        window.open(environment.pageSampleFile, '_blank');
      }

    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function getConfigExport() {
        getExportConfig(storeUrl,"page").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
                if (result.status === "completed") {
                    setExportLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                    
                }
                else if (result.status  === "failed") {
                    setExportLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                }
                else {
                    setExportLoading(true);
                    setExportStatus(result.status);
                }
            }
        });
    }
}